import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M0 0h24v24H0z" }),
      _createElementVNode("path", {
        fill: "#FFF",
        "fill-rule": "nonzero",
        d: "M22 9.214s.073-3.583-1.875-5.593c-.92-.95-2.123-1.43-3.577-1.43H4.544A2.547 2.547 0 0 0 2 4.734v13.724a3.355 3.355 0 0 0 3.351 3.35h13.297A3.355 3.355 0 0 0 22 18.46zM4.544 3.53h12.004c1.09 0 1.945.333 2.612 1.02.486.5.814 1.133 1.037 1.768-.381-.199-.806-.38-1.549-.38H4.544c-.663 0-1.204-.54-1.204-1.204S3.88 3.53 4.544 3.53M20.66 13.544h-1.19a.67.67 0 1 0 0 1.34h1.19v1.384h-1.528a2.013 2.013 0 0 1-2.01-2.01v-.087c0-1.109.902-2.01 2.01-2.01h1.528zm0-2.724h-1.528a3.355 3.355 0 0 0-3.35 3.351v.086a3.355 3.355 0 0 0 3.35 3.351h1.528v.85c0 1.11-.902 2.011-2.01 2.011H5.35a2.013 2.013 0 0 1-2.01-2.01V6.975c.358.193.768.303 1.203.303h14.104c1.11 0 2.011.902 2.011 2.01z"
      })
    ], -1)
  ]))]))
}
export default { render: render }